<ol class="mat-breadcrumb breadcrumb" *ngIf="breadcrumbs.length > 0">
  <li *ngFor="let breadcrumb of breadcrumbs; let i = index" [class.active]="i === breadcrumbs.length - 1">
    <a [routerLink]="'/gca' + breadcrumb.url" *ngIf="i !== breadcrumbs.length - 1">{{ breadcrumb.label }}</a>
    <span *ngIf="i === breadcrumbs.length - 1">
      {{ breadcrumb.label }}
    </span>
  </li>
</ol>
